import Vue from 'vue';
import App from './views/index/index';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import '@/utils/rem';
import 'element-ui/lib/theme-chalk/index.css';
import vant from 'vant';
import 'vant/lib/index.css';

// import 'swiper/swiper-bundle.min.css'
// import 'swiper/swiper-bundle.min'

// //修改了下面这行代码 swiper中的page需要单独引入，否则不显示 自动播放也是需要引入
// import Swiper, {Navigation, Pagination,Autoplay} from "swiper";
// //新加了下面这行代码
// Swiper.use([Navigation, Pagination,Autoplay]);
// new Swiper('.swiper')
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import 'element-ui/lib/theme-chalk/display.css';
import { Lazyload } from 'vant';
// 全局挂载
Vue.use(VueAwesomeSwiper);
Vue.use(vant);

Vue.config.productionTip = false;
Vue.use(ElementUI);

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});

new Vue({
  router,
  store,
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  render: (h) => h(App),
}).$mount('#app');
